<template>
<f7-app v-bind="f7params">
  <f7-view main url="/welcome"/>
</f7-app>
</template>

<script>
import routes from '@/lib/routes'

export default {
  data () {
    return {
      f7params: {
        theme: 'aurora',
        routes
      }
    }
  }
}
</script>
